module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Moviles-4-zoom.37e5f6cf.png";